export enum NpsEvent {
  NpsFeedbackSubmitter = 'NPS Feedback Submitted',
}

export enum AppEvent {
  MapLoaded = 'Map Loaded',
  AccountSignOut = 'Account Sign Out',
  AccountSignInStarted = 'Account Sign In Started',
  AccountSignInSucceeded = 'Account Sign In Succeeded',
  AccountSignInFailed = 'Account Sign In Failed',
  AccountCreationStarted = 'Account Creation Started',
  AccountCreationSucceeded = 'Account Creation Succeeded',
  AccountCreationFailed = 'Account Creation Failed',
  CollectionsReadRequested = 'Collections Read Requested',
  CollectionsReadSucceeded = 'Collections Read Succeeded',
  CollectionsReadFailed = 'Collections Read Failed',
  CollectedPlacesReadRequested = 'Collected Places Read Requested',
  CollectedPlacesReadSucceeded = 'Collected Places Read Succeeded',
  CollectedPlacesReadFailed = 'Collected Places Read Failed',
  CollectionCreated = 'Collection Created',
  CollectionModified = 'Collection Modified',
  CollectionDeleted = 'Collection Deleted',
  RouteRequested = 'Route Requested',
  RouteRequestSucceeded = 'Route Request Succeeded',
  RouteRequestFailed = 'Route Request Failed',
  UnhandledErrorOccured = 'Unhandled Error Occurred',
  ExternalLinkOpened = 'External Link Opened',
  HistoryCleared = 'History Cleared',
}
